import Vue from 'vue'
import i18n from '@/plugins/i18n'

Vue.filter('formatDate', (value) => {
  let fecha = ""
  switch (i18n.locale) {
    case 'es':
      if (!value) return ''
      fecha = value.split("T")[0]
      fecha = fecha.split("-")
      fecha = fecha[2] + "/" + fecha[1] + "/" + fecha[0]
      return fecha
    case 'en':
      if (!value) return ''
      fecha = value.split("T")[0]
      fecha = fecha.split("-")
      fecha = fecha[1] + "/" + fecha[2] + "/" + fecha[0]
      return fecha
    default:
      if (!value) return ''
      fecha = value.split("T")[0]
      fecha = fecha.split("-")
      fecha = fecha[2] + "/" + fecha[1] + "/" + fecha[0]
      return fecha
  }
});

Vue.filter('defaultEmpty', (value) => {
  if(!value || value == "") return "---"
  else return value
});

Vue.filter("formatPrice", (value) => {
  if(value==="") return "";
  let val = (value / 1).toFixed(2).replace(".", ",");
  return "$ " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

Vue.filter("descarteNulo", (value) => {
  if (value == -1) return "";
  return value;
});
